(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/quickplay-modal/assets/javascripts/helpers.js') >= 0) return;  svs.modules.push('/components/sport/quickplay-modal/assets/javascripts/helpers.js');
"use strict";


const {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo
} = React;
const {
  productIds
} = svs.utils.products;
const SystemTypes = Object.freeze({
  MSYS: 'MSYS',
  SROW: 'SROW',
  RSYS: 'RSYS',
  USYS: 'USYS'
});
const QuickpickProps = Object.freeze({
  WEIGHTEDQP: 'WEIGHTEDQP',
  MODIFIEDQP: 'MODIFIEDQP',
  NOQP: 'no-qp',
  PARTIALQP: 'PARTIALQP',
  XPERTEN: 'XPERTEN'
});

function is1X2(productId) {
  switch (productId) {
    case productIds.CHALLENGE:
    case productIds.STRYKTIPSET:
    case productIds.EUROPATIPSET:
    case productIds.POWERPLAY:
    case productIds.T8STRYK:
    case productIds.T8EXTRA:
    case productIds.T8:
      return true;
    default:
      return false;
  }
}

function useAsyncSafeState(initValue) {
  const [value, setValue] = useState(initValue);
  const isMountedRef = useRef(true);
  useEffect(() => () => {
    isMountedRef.current = false;
  }, []);
  const asyncSafeSetValue = useCallback(data => {
    if (isMountedRef.current) {
      setValue(data);
    }
  }, []);
  return useMemo(() => [value, asyncSafeSetValue], [value, asyncSafeSetValue]);
}

const getNumberOfRows = (systemCost, rowPrice) => systemCost / (rowPrice || 1);
setGlobal('svs.components.sport.quickplayModal.helpers', {
  getNumberOfRows,
  is1X2,
  useAsyncSafeState,
  SystemTypes,
  QuickpickProps
});

 })(window);